const MinPageSize = 10;
const QuarterPageSize = 25;
const MediumPageSize = 50;
const MaxPageSize = 100;
const Basic = [MinPageSize, QuarterPageSize, MediumPageSize, MaxPageSize];
const Options = Basic.map(value => ({
    name: value.toString(),
    value,
}));
const DefaultPageSize = MinPageSize;
const DefaultMediumPageSize = QuarterPageSize;
export default Basic;
export const EdComDefaultPageSize = 5;
export { Basic, Options, MinPageSize, QuarterPageSize, MediumPageSize, MaxPageSize, DefaultPageSize, DefaultMediumPageSize, };
